import { store } from "../app/store";
import { setShowServerErrorMessage } from "../reducers/errorManagementSlice";

const fetchMobileStepper = async (languageCode, setMobileStepper) => {
  const baseUrl = process.env.REACT_APP_API;

  const res = await fetch(`${baseUrl}/api/stepper/`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Accept-Language": languageCode === "en" ? "en-UK" : languageCode,
    },
  });

  store.dispatch(setShowServerErrorMessage(res.status));

  const jsonData = await res.json();

  const stepperData = jsonData?.page_content?.stepper_list?.map((step) => {
    return { label: step.value.title, text: step.value.text };
  });
  setMobileStepper(stepperData);
  return { stepperData, responseStatus: res.status };
};

export default fetchMobileStepper;
